import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "../../../pages/home";
import { routePath as RP } from "./routepath";
import StudentDashboardForm from "../../../pages/studentscholarship/Studentdashboard";
import ScholarshipDiscoveryForm from "../../../pages/discoverscholarship/ScholarshipDiscovery";
import ScholarshipMatch from "../../../pages/AIScholarshipmatch/ScholarshipMatch";
import SponsorDashboard from "../../../pages/SponsorDashboard/Dashboard";
import Header from "../../components/header/header";
import LoginPage from "../../../pages/login/login";
import SignUpPage from "../../../pages/login/signup";
import StudentWalletRedemption from "../../../pages/student/studentwaletredemption";
import StudentWallet from "../../../pages/student/studentwalet";
import StudentRedemptionCatalog from "../../../pages/student/studentredemptioncalog";
import StudentRewards from "../../../pages/student/studentrewards";
import SponsorDashboardReport from "../../../pages/SponsorDashboardReport/SponsorDashboardReport";
import StudentRewardsRedemption from "../../../pages/student/studentrewardsredemption";
import StudentProfile from "../../../pages/student/Profile/studentprofile";
import ViewStudentProfile from "../../../pages/student/Profile/viewprofile";
import ViewSponsorProfile from "../../../pages/sponser/profile/viewProfile.jsx";
import SponsorProfileForm from "../../../pages/sponser/profile/sponsorProfile.jsx";
import MessagesPage from "../../../pages/student/message.jsx";
import MonetizationAds from "../../../pages/MonetizationAds/MonetizationAds";
import SponsorAdDashboard from "../../../pages/SponsorAdDashboard/SponsorAdDashboard";
import SponsorApplications from "../../../pages/SponsorDashboard/SponsorApplications";
import QueryAdminList from "../../../pages/SponsorDashboard/QuerryAdminList.jsx";
import ScholarshipPage from "../../../pages/SponsorDashboard/SponsorScholarship/ScholarshipPage.jsx";
import AddScholarshipPage from "../../../pages/SponsorDashboard/SponsorScholarship/AddScholarshipPage.jsx"
import ApplicationsPage from "../../../pages/student/scholarshipapplication/studentApplication.jsx";
import AddApplicationPage from "../../../pages/student/scholarshipapplication/addApplication.jsx";
////import ApplicationsPage from "../../../pages/student/studentApplication";
//import AddApplicationPage from "../../../pages/student/addApplication";
import SponsorSettings from "../../../pages/SponsorDashboard/Settings";
import SponsorSignUpPage from "../../../pages/login/Sponsorsignup.jsx";
import InstitutionSignUpPage from "../../../pages/login/Institutionsignup.jsx";
import ResetPassword from "../../../pages/Resetpassword/Resetpassword.jsx";
import ScholarshipViewPage from "../../../pages/studentscholarship/view.jsx";
import LoginSuccess from "../../../pages/login/loginsuccess.jsx";
import SponsoredScholarship from "../../../pages/SponsorDashboard/SponsoredScholarship.jsx";
import ForgotPassword from "../../../pages/ForgotPassword/forgotPassword.jsx";
import ViewApplication from "../../../pages/student/scholarshipapplication/viewApplication.jsx";
import TermsAndConditions from "../../../pages/termsandcondition.jsx";
import FacultyDashboard from "../../../pages/Faculty/dashboard.jsx";
import FacultySignup from "../../../pages/login/facultySignup.jsx";
import InstitutionsPage from "../../../pages/InstitutionsPage.jsx";
import ContactUs from "../../../pages/contact.jsx";
import InstitutionViewPage from "../../../pages/InstitutionDetailsview.jsx";
// ⭐ ADD THIS IMPORT
import ChatWidget from "../chatwidget.jsx";// 🔹 Map routes to header variants
import PrivacyPolicy from "../../../pages/privacypolicy.jsx";
import ViewFacultyProfile from "../../../pages/Faculty/login/viewProfile.jsx";
import FacultyProfile from "../../../pages/Faculty/login/facultyProfile.jsx";
import TermsAndUse from "../../../pages/termsofuse.jsx";
const routeToVariant = {
  [RP.home]: "public",
  [RP.studentdashboard]: "student-profile",
  [RP.scholarshipdiscovery]: "discovery",
  [RP.scholarshipmatch]: "student",
  [RP.sponsordashboard]: "sponsor-profile",
  [RP.login]: "public",
  [RP.signup]: "public",
  [RP.ViewSponsorProfile]:"sponsor-profile",
  [RP.sponsorprofile]:"sponsor-profile",
  [RP.studentprofile]:"student-profile",
  [RP.ViewStudentProfile]:"student-profile",
  [RP.resetPassword]:"profile-role-based",
  [RP.studentwalletredemption]: "studentwalletredemption",
  [RP.studentwallet]: "studentwallet",
  [RP.studentredemptioncalog]: "studentredemptioncalog",
  [RP.studentrewards]: "studentrewards",
  [RP.studentrewardsredemption]: "studentrewardsredemption",
  [RP.sponsordashboardreport]: "sponsordashboardreport",

 // [RP.resetPassword]

  [RP.monetizationads]: "monetizationads",
  [RP.sponsoraddashboard]: "sponsoraddashboard",
  [RP.applications]: "student-profile",
  [RP.addapplication]: "student-profile",
  [RP.sponsorapplication]:"sponsorapplication",
  [RP.studentQueries]:"sponsorapplication",
  [RP.SponsorSignUpPage]:"sponsorsignup",
  [RP.scholarshipPage]:"scholarshippage",
 [RP.scholarshipViewPage]: "student-profile",
  [RP.loginSuccess]:"public",
  [RP.SponsoredScholarship]:"sponsor-profile",
  [RP.facultyDashboard]:"faculty-profile",
  [RP.facultySignup]:"faculty-profile",
  [RP.viewFacultyProfile]:"faculty-profile",
  [RP.facultyProfile]:"faculty-profile",
  [RP.InstitutionsPage]: "Institutions-list",
  [RP.InstitutionViewPage]: "Institution-view",

};

// 🔹 Layout wrapper
function Layout({ children }) {

  const location = useLocation();

  // ⭐ CHANGED: ChatWidget now stays mounted for logged-out users too.
  // We only hide it on pages where it makes no sense to show it (login,
  // signup screens). We show it on home page and all other pages so users
  // can access FAQ and Help & Support. We no longer key this off token/expiry —
  // the widget's own FAQ button must work without login, and
  // ChatWidget already prompts for login internally when someone taps
  // "Chat with AI" or "Raise a Query" while logged out.
  const hideChat =
    location.pathname === "/login" ||
    location.pathname === "/signup" ||
    location.pathname === "/sponsor/signup" ||
    location.pathname === "/institution/signup";

  const variant = routeToVariant[location.pathname] || "public";

  return (
    <>
      <Header variant={variant} />

      {/* ⭐ Hide ChatWidget only on the pages listed above — otherwise
          show it regardless of login state, so FAQ is always reachable */}
      {!hideChat && <ChatWidget />}

      <main>{children}</main>
    </>
  );
}


function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path={RP.home} element={<Home />} />
          <Route path={RP.studentdashboard} element={<StudentDashboardForm />} />
          <Route path={RP.scholarshipdiscovery} element={<ScholarshipDiscoveryForm />} />
          <Route path={RP.scholarshipmatch} element={<ScholarshipMatch />} />
          <Route path={RP.sponsordashboard} element={<SponsorDashboard />} />
          <Route path={RP.login} element={<LoginPage />} />
          <Route path={RP.signup} element={<SignUpPage />} />
          <Route path={RP.studentwallet} element={<StudentWallet />} />
          <Route path={RP.studentwalletredemption} element={<StudentWalletRedemption />} />
          <Route path={RP.studentredemptioncalog} element={<StudentRedemptionCatalog />} />
          <Route path={RP.studentrewards} element={<StudentRewards />} />
          <Route path={RP.sponsordashboardreport} element={<SponsorDashboardReport />} />
          <Route path={RP.studentrewardsredemption} element={<StudentRewardsRedemption />} />
          <Route path={RP.studentprofile} element={<StudentProfile />} />
          <Route path={RP.ViewStudentProfile} element={<ViewStudentProfile />} />
          <Route path={RP.ViewSponsorProfile} element={<ViewSponsorProfile />} />
          <Route path={RP.sponsorprofile} element={<SponsorProfileForm />} />
          <Route path={RP.studentmessages} element={<MessagesPage />} />
          <Route path={RP.monetizationads} element={<MonetizationAds />} />
          <Route path={RP.sponsoraddashboard} element={<SponsorAdDashboard />} />
          <Route path={RP.sponsorapplication} element={<SponsorApplications />} />
          <Route path={RP.scholarshipPage} element={<ScholarshipPage />} />
          <Route path={RP.studentQueries} element={<QueryAdminList />} />
          <Route path={RP.applications} element={<ApplicationsPage />} />
          <Route path={RP.addapplication} element={<AddApplicationPage />} />
          <Route path={RP.settings} element={<SponsorSettings />} />
          <Route path={RP.signupSponsor} element={<SponsorSignUpPage />} />
          <Route path={RP.signupInstitution} element={<InstitutionSignUpPage />} />
          <Route path={RP.addscholarshippage} element={<AddScholarshipPage />} />
          <Route path={RP.resetPassword} element={<ResetPassword />} />
          <Route path={RP.scholarshipViewPage} element={< ScholarshipViewPage />} />
          <Route path={RP.loginSuccess} element={< LoginSuccess />} />
          <Route path={RP.SponsoredScholarship} element={<SponsoredScholarship />} />
          <Route path={RP.ForgotPassword} element={<ForgotPassword />} />
          <Route path={RP.viewApplication} element={<ViewApplication />} />
          
           <Route path={RP.facultyDashboard} element={<FacultyDashboard />} />
             <Route path={RP.facultySignup} element={<FacultySignup />} />
  <Route path={RP.viewFacultyProfile} element={<ViewFacultyProfile />} />
               <Route path={RP.facultyProfile} element={<FacultyProfile />} />
           <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/contact" element={<ContactUs />} />
         <Route path="/privacy" element={<PrivacyPolicy />} />
           <Route path="/termsofuse" element={<TermsAndUse />} />
         <Route path={RP.InstitutionsPage} element={<InstitutionsPage/>} />
<Route path="/institution/view/:id" element={<InstitutionViewPage />} />

        </Routes>
      </Layout>
    </Router>
  );
}

export default App;